var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sdr-box contact-box" }, [
    _c("h4", {
      domProps: {
        innerHTML: _vm._s(_vm.importantinfosheader[_vm.getCurrentLocale]),
      },
    }),
    _vm._v(" "),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(_vm.importantinfostext[_vm.getCurrentLocale]),
      },
    }),
    _vm._v(" "),
    _c("address", { staticClass: "contact-details" }, [
      _c("span", { staticClass: "contact-phone" }, [
        _c("i", { staticClass: "soap-icon-message" }),
        _vm._v(" " + _vm._s(_vm.download[_vm.getCurrentLocale])),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "contact-email",
          attrs: {
            href: "https://www.mein-wunschplatz.de/downloads/Sonderreservierungen_Vollcharter_SIL.pdf",
            target: "_blank",
          },
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.download2[_vm.getCurrentLocale]) +
              "\n        "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }